// extracted by mini-css-extract-plugin
export default {"title":"Products_title__+KQkQ","titleContainer":"Products_titleContainer__EC76I","gridContainer":"Products_gridContainer__zHhzi"};